<template>
  <div
    v-for="item in props.treeData"
    :key="item.id"
    :class="item.children.length > 0 && item.expand ? 'region-border' : ''"
  >
    <div class="after-sale-person" :style="treeStyle">
      <div class="df person-info">
        <div class="job-title one-row">安视康医疗</div>
        <div class="user-name">{{ item.username }}</div>
      </div>
      <div class="df action">
        <div @click="addOrEditSale(false, item)">新增账号</div>
        <div @click="addOrEditSale(true, item)">编辑</div>
        <div @click="doDelete(item)">删除</div>
        <div @click="setAuthority(item)">权限设置</div>
        <div
          @click="expand(item)"
          v-if="item.children && item.children.length > 0"
        >
          {{ item.expand ? "收起" : "展开" }}
        </div>
      </div>
    </div>

    <template v-if="item.expand">
      <list-tree
        :treeData="item.children"
        :treeLevel="props.treeLevel + 1"
        @updateList="updateList"
      ></list-tree>
    </template>
  </div>

  <div class="modal" v-if="customModal.visiable" @click="handleCancel">
    <div class="modal-content">
      <div class="title" @click.stop="">{{ customModal.title }}</div>
      <div class="button">
        <div class="border-right" @click.stop="handleCancel">取消</div>
        <div @click.stop="handleCheck">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, watch, reactive } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "@/utils";
import { deleteUser } from "@/request/view/repair";

export default defineComponent({
  name: "listTree",
  props: {
    treeData: Array,
    treeLevel: Number,
  },
  setup(props, context) {
    const router = useRouter();

    const treeStyle = computed(() => {
      return { marginLeft: `${props.treeLevel * 15}px` };
    });

    const expand = (record) => {
      record.expand = !record.expand;
    };

    const addOrEditSale = (isEdit, data) => {
      router.push({
        path: "/mobilemenu/pageaction",
        query: {
          name: "salePerson",
          data: JSON.stringify(data),
          type: isEdit ? "editSale" : "addSale",
        },
      });
    };

    // 权限设置
    const setAuthority = (data) => {
      router.push({
        path: "/mobilemenu/pageaction",
        query: {
          name: "authority",
          data: JSON.stringify(data),
          type: "authority",
        },
      });
    };

    // 模态框
    const customModal = reactive({
      visiable: false,
      title: "",
      id: "",
    });

    const handleCancel = () => {
      customModal.visiable = false;
      customModal.title = "";
    };

    const doDelete = (item) => {
      customModal.visiable = true;
      customModal.id = item.id;
      customModal.title = "确认删除？";
    };

    const handleCheck = () => {
      deleteUser([customModal.id])
        .then((res) => {
          if (res.code === 200) {
            Toast("success", res.message, 3);
            context.emit("updateList");
          }
          handleCancel();
        })
        .catch((err) => {
          handleCancel();
        });
    };

    const updateList = () => {
      context.emit("updateList");
    };

    watch(
      () => props.treeData,
      (val) => {
        if (val) {
          val.forEach((item) => {
            if (item.expand === undefined) item.expand = true;
          });
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      treeStyle,
      doDelete,
      expand,
      addOrEditSale,
      setAuthority,
      handleCancel,
      customModal,
      handleCheck,
      updateList,
    };
  },
});
</script>

<style lang="less" scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100vw;
  height: 100vh;
  .modal-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 9.2rem;
    height: 3.43rem;
    background: #ffffff;
    box-shadow: 0rem 0.01rem 0.07rem 0rem rgba(38, 38, 38, 0.1);
    border-radius: 0.24rem;
    .title {
      height: 2.01rem;
      border-bottom: 1px solid #979797;
      font-size: 0.4rem;
      color: #11171e;
      line-height: 2.01rem;
      text-align: center;
    }
    .button {
      height: 1.39rem;
      display: flex;
      font-size: 0.4rem;
      color: #11171e;
      line-height: 1.39rem;
      text-align: center;
      .border-right {
        border-right: 1px solid #979797;
      }
    }
    .button > div {
      width: 50%;
    }
  }
}

.region-border {
  padding: 5px;
  border: 1px solid #179a90;
  border-radius: 5px;
  margin-bottom: 0.45rem;
}

.after-sale-person {
  background: url("../../../../assets/img/mobile/page/authority-background.png");
  width: 8rem;
  //   height: 2.61rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin: 0 auto 0.5rem;
  padding: 0.71rem 0.45rem 0.33rem;
  .person-info {
    .job-title {
      font-size: 0.43rem;
      font-weight: bold;
      color: #143022;
      margin-right: 0.84rem;
      width: 2.45rem;
    }
    .user-name {
      font-size: 0.37rem;
      font-weight: bold;
      color: #18412d;
    }
  }
  .action {
    margin-top: 0.5rem;
    font-size: 0.35rem;
    color: #179a90;
    div {
      margin-right: 0.5rem;
    }
    div:last-child {
      margin-right: 0;
    }
  }
}
</style>
